import store from 'public/store'

export function getNodeTextContent (node) {
  return node ? node.textContent : ''
}

export function getCurrentRouteInfo() {
  const { currentRoute } = window.__ERP_PUBLIC_SHARED_ROUTER__ || {}
  return currentRoute || {}
}


export function enableCopyMultipleFeature () {
  const lookUpOptions = store.getters.lookUpOptions || {}
  const [switchFlag] = lookUpOptions['sys_copy_multiple_switch'] || []
  const blackRouter = lookUpOptions['sys_copy_multiple_blacklist_router'] || []
  if (!switchFlag || switchFlag.value !== '1') {
    return false
  }
  const { path } = getCurrentRouteInfo()
  const isBlackRouter = blackRouter.length && blackRouter.some(i => path.indexOf(i.value) > -1)
  if (isBlackRouter) {
    return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/public/plugins/copy-cells/utils.js